import { useEffect } from "react";
import { X } from "lucide-react";

export default function Modal({ title, onClose, wide = false, children }) {
  useEffect(() => {
    const onKey = (event) => event.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div className="mb-modal-backdrop" onPointerDown={(event) => event.target === event.currentTarget && onClose()}>
      <div className={`mb-modal${wide ? " is-wide" : ""}`} role="dialog" aria-modal="true" aria-label={title}>
        <header className="mb-modal-head">
          <h2>{title}</h2>
          <button type="button" className="mb-icon-button" onClick={onClose} aria-label="Close">
            <X size={18} strokeWidth={1.8} />
          </button>
        </header>
        <div className="mb-modal-body">{children}</div>
      </div>
    </div>
  );
}
